export interface IMultipleDateConfigiration {
  dateRange?: {
    from: Date;
    to: Date;
  };
  validations?: Array<(...params: Array<{ [key: string]: any }>) => boolean>;
  cellCutomClasses?: (date: Date, params: Array<any>) => string | string[];
}

export enum DatePickerHeaderMode {
  Month = 'month',
  Year = 'year'
}

export interface IMultiDatePanelItem {
  date: Date;
  dateFilter: (date: Date) => boolean;
}
